import React from 'react';
import v from 'vudu';
import copy from 'constants/copy';
import Text from 'components/Text';
import { styles as s, classes as c, format as f, colors, breakpoints } from 'stylesheet';
import sizes from 'constants/sizes';
import { Link } from 'react-router-dom';
import Arrow from 'components/svgs/Arrow';

const localClasses = v({
  termsView: {
    paddingTop: '80px',
    height: `calc(100% - ${sizes.navHeight})`,
    display: 'flex',
    flexDirection: 'column'
  },
  hero: {
    width: '100%',
    maxWidth: '500px',
    width: '90%',
    marginBottom: '10px',
    textAlign: 'center',
    margin: '0px auto 0px auto',
    borderBottom: `1px solid ${colors.taupe}`,
  },
  body: {
    maxWidth: '860px',
    width: '90%',
    height: '100%',
    overflow: 'scroll',
    textAlign: 'center',
    margin: '0px auto 0px auto',
    //maskImage: `-webkit-gradient(linear, left 60%, left bottom, from(rgba(0,0,0,1)), to(rgba(0,0,0,0)))`,
    'p': { marginBottom: '60px' }
  },
  back: {
    padding: '20px 0',
    textAlign: 'center',
    'a': { textDecoration: 'none' }
  },


  button: {
    backgroundColor: colors.ebony,
    border: `solid 1px ${colors.transparent}`,
    transition: '140ms ease-in-out',
    display: 'inline-flex',
    alignItems: 'center',
    padding: '0.75rem',
    opacity: 0.4,
    lineHeight: 1,
    height: '40px',
    [breakpoints.md]: {
      backgroundColor: colors.transparent,
    }
  },
  backButton: {
    'p': {
      transition: '140ms ease-in-out',
    },
    'svg g': {
      transition: '140ms ease-in-out',
    },
  },
  backActive: {
    opacity: 1,
    cursor: 'pointer',
    'p': { color: colors.white },
    'svg g': { fill: colors.white },
    ':hover': {
      'p': { color: colors.razzmatazz },
      'svg g': { fill: colors.razzmatazz }
    },
  },
});

const makeMarkdown = (raw) => {
  let converter = new window.showdown.Converter();
  return converter.makeHtml(raw);
}

export default () => {

  let backFill    = colors.white;
  let backClasses = `${localClasses.button} ${localClasses.backButton} ${localClasses.backActive}`;
  let backColor   = 'razzmatazz';

  return (
    <section className={localClasses.termsView}>
      <div className={localClasses.hero}>
        <Text variant={'headline'} color={'white'}>{copy.termsView.heading}</Text>
        <Text variant={'subheadline'} color={'taupe'} classes={c.pb3}>{copy.termsView.subheading}</Text>
      </div>
      <div className={localClasses.body} dangerouslySetInnerHTML={{ __html: makeMarkdown(copy.termsView.termsBody) }}></div>
      <div className={localClasses.back}>
        <Link to='/'>
          <div className={f(backClasses, c.mr2)}>
            <Arrow className={c.rotate180} fill={backFill} />
            <Text color={backColor} classes={f(c.pl2, localClasses.textOffset)} variant={'smallTracked'}>back</Text>
          </div>
        </Link>
      </div>
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/views/TermsView.js